import { css } from 'styled-components';
export const BasicButton = css `
  font-weight: ${(props) => props.theme.bold};
  cursor: pointer;
  color: #fff;
  border: none;
  border-radius: 4px;
  outline-style: none;
  box-shadow: none;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;

  &:focus {
    outline: none;
  }

  &:hover {
    text-decoration: none;
  }

  &:disabled {
    opacity: 0.72;
    cursor: not-allowed;
  }
`;
export const getButtonColors = (type) => {
    switch (type) {
        case 'Primary':
            return css `
        background-color: ${(props) => props.theme.curiousBlue};
        color: ${(props) => props.theme.white};

        &:hover {
          color: #fff;
          background-color: ${(props) => props.theme.matisse};
        }

        &:focus {
          background-color: ${(props) => props.theme.curiousBlue};
        }

        &:active {
          background-color: ${(props) => props.theme.bigStone};
          color: ${(props) => props.theme.white};
        }
      `;
        case 'PrimaryLight':
            return css `
        background-color: ${(props) => props.theme.new12};
        color: ${(props) => props.theme.darkBlue};

        &:hover {
          color: #fff;
          background-color: ${(props) => props.theme.curiousBlue};
        }

        &:focus {
          background-color: ${(props) => props.theme.new12};
        }

        &:active {
          background-color: ${(props) => props.theme.bigStone};
          color: ${(props) => props.theme.white};
        }
      `;
        case 'Secondary':
            return css `
        background-color: ${(props) => props.theme.bigStone};
        color: ${(props) => props.theme.white};

        &:hover {
          background-color: ${(props) => props.theme.new1};
          color: ${(props) => props.theme.bigStone};
        }

        &:focus {
          background-color: ${(props) => props.theme.new2};
          color: ${(props) => props.theme.new3};
        }

        &:active {
          background-color: ${(props) => props.theme.bigStone};
          color: ${(props) => props.theme.white};
        }
      `;
        case 'Tertiary':
            return css `
        background-color: ${(props) => props.theme.new2};
        color: ${(props) => props.theme.new3};

        &:hover {
          background-color: ${(props) => props.theme.curiousBlue};
          color: ${(props) => props.theme.white};
        }

        &:focus {
          background-color: ${(props) => props.theme.new2};
          color: ${(props) => props.theme.new3};
        }

        &:active {
          background-color: ${(props) => props.theme.bigStone};
          color: ${(props) => props.theme.white};
        }

        .icon-fill {
          fill: ${(props) => props.theme.new3};
        }
      `;
        case 'Positive':
            return css `
        background-color: ${(props) => props.theme.new4};
        color: ${(props) => props.theme.white};

        &:hover {
          background-color: ${(props) => props.theme.new5};
        }

        &:focus {
          background-color: ${(props) => props.theme.new4};
        }

        &:active {
          background-color: ${(props) => props.theme.bigStone};
          color: ${(props) => props.theme.white};
        }
      `;
        case 'Danger':
            return css `
        background-color: ${(props) => props.theme.new6};
        color: ${(props) => props.theme.white};

        &:hover {
          background-color: ${(props) => props.theme.new7};
        }

        &:focus {
          background-color: ${(props) => props.theme.new6};
        }

        &:active {
          background-color: ${(props) => props.theme.bigStone};
          color: ${(props) => props.theme.white};
        }
      `;
        case 'Transparent':
            return css `
        background-color: transparent;
        color: ${(props) => props.theme.darkGray};

        &:active {
          color: ${(props) => props.theme.darkGray};
        }
      `;
        default:
            throw new Error('Button type is not defined');
    }
};
export const getReverseButtonColors = (type) => {
    switch (type) {
        case 'Danger':
            return css `
        background-color: #fff;
        color: ${(props) => props.theme.buttonDanger};
        box-shadow: 0 0 0 1px ${(props) => props.theme.buttonDanger} inset;

        &:hover {
          color: ${(props) => props.theme.buttonDanger};
        }
      `;
        default:
            throw new Error('Reverse button type is not defined');
    }
};
export const getButtonSize = (size) => {
    switch (size) {
        case 'Small':
            return css `
        padding: 3px 8px;
        font-size: ${(props) => props.theme.fontXXSmall};
        line-height: 18px;
      `;
        case 'Medium':
            return css `
        padding: 6px 16px 5px 16px;
        font-size: ${(props) => props.theme.fontSmall};
        line-height: 21px;
      `;
        case 'Standard':
            return css `
        padding: 10px 16px 9px 16px;
        font-size: ${(props) => props.theme.fontSmall};
        line-height: 21px;
      `;
        case 'StandardWide':
            return css `
        padding: 10px 32px 9px 32px;
        font-size: ${(props) => props.theme.fontSmall};
        line-height: 21px;
      `;
        case 'Large':
            return css `
        padding: 12px 24px 12px 24px;
        font-size: ${(props) => props.theme.fontMedium};
        line-height: 24px;
      `;
        default:
            throw new Error('button size is not defined');
    }
};
